export const PHONE_ANALYTIC_ATTRIBUTE = 'data-analytics-phone';
